import React from "react";
import { MultiSelectListOqt } from "../";

export const SimpleSelectListOqt = (props) => {
    return <MultiSelectListOqt isMulti={false} {...props}/>;
}
